<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Help</div>

          <div class="card-body">
            <ul class="list-group list-group-flush">
              <li class="list-group-item"><a href="/#/support/the-story">The story</a></li>
              <li class="list-group-item"><a href="/#/support/ledgers">What exactly is a ledger?</a></li>
              <li class="list-group-item"><a href="/#/support/expenses">How to handle expenses</a></li>
              <li class="list-group-item"><a href="/#/support/dashboard">Dashboard</a></li>
              <li class="list-group-item"><a href="/#/support/example-ledger">Example ledger</a></li>
              <li class="list-group-item"><a href="/#/support/add-to-home-screen">Install the app on mobile devices</a></li>
              <li class="list-group-item"><a href="/#/support/keyboard-shortcuts">Keyboard shortcuts</a></li>
              <li class="list-group-item"><a href="/#/terms-of-service">Terms of service</a></li>
              <li class="list-group-item"><a href="/#/privacy-policy">Privacy policy</a></li>
              <li class="list-group-item"><a href="/#/cookie-policy">Cookie policy</a></li>
              <li class="list-group-item"><a href="/#/support/contact">Contact</a></li>
            </ul>
            <br>
            <div id="app-version">App version 1.84</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Support',
  data () {
    return {}
  }
}
</script>

<style>
  #app-version{
    width: 100%;
    text-align: center;
    font-size: 13px;
    color: #c3c3c3;
  }
</style>
